import React from 'react';
import { Card, CardContent } from './ui/card';
import { Construction } from 'lucide-react';

const PlaceholderPage = ({ title }) => {
  return (
    <div className="flex-1 overflow-y-auto bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-8 py-6">
        <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
      </div>

      <div className="p-8 flex items-center justify-center h-full">
        <Card className="max-w-md">
          <CardContent className="pt-6 text-center">
            <Construction className="w-16 h-16 text-gray-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Coming Soon
            </h2>
            <p className="text-gray-600">
              This module is under development and will be available soon.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PlaceholderPage;
